export default __webpack_public_path__ + "images/b1e925fbc20c065b734df68e849ff8b6-menu-cat-friend.svg";